import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 px-4 overflow-hidden bg-slate-950" data-id="element-46">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-900/30 blur-[120px] rounded-full pointer-events-none" data-id="element-47"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-49">
          <span className="inline-block py-1 px-3 rounded-full bg-teal-950 border border-teal-800 text-teal-400 text-sm font-bold tracking-widest uppercase mb-6" data-id="element-50">
            Atención profesionales de la salud
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-51">
            Si sentís que tu práctica podría ser más{' '}
            <span className="text-teal-400" data-id="element-52">ordenada</span>, más{' '}
            <span className="text-teal-400" data-id="element-53">precisa</span> y más{' '}
            <span className="text-teal-400" data-id="element-54">profesional</span>… seguí leyendo.
          </h1>

          <p className="text-xl md:text-2xl text-slate-300 mb-10 font-medium" data-id="element-55">
            Porque lo que estás a punto de descubrir puede cambiar completamente
            tu forma de trabajar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-12 max-w-2xl mx-auto" data-id="element-56">
          <ProductImage data-id="element-57" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-58">
          <CTAButton data-id="element-59" />
        </motion.div>
      </div>
    </section>;
}